import { getData, postData, putData } from 'src/api/http.service';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

const SubjectReviewActionTypes = {
  ALL_FINISHED_SUBJECTS_SUCCESS: '[API] : Get all finished subjects action.',
  REVERT_OR_DECLINE_SUBJECT: '[API] : Revert or decline subject.',
  REVERT_OR_DECLINE_SUBJECT_SUCCESS: '[API] : Revert or decline subject success.',
  APPROVE_A_SUBJECT: '[API] : Approve a subject action.',
  APPROVE_A_SUBJECT_SUCCESS: '[API] : Approve a subject success.',
};

/*
    Plain Actions
*/

function AllFinishedSubjectsSuccessAction(payload) {
  return {
    type: SubjectReviewActionTypes.ALL_FINISHED_SUBJECTS_SUCCESS,
    payload,
  };
}

function RevertOrDeclineSuccessAction(payload) {
  return {
    type: SubjectReviewActionTypes.REVERT_OR_DECLINE_SUBJECT_SUCCESS,
    payload,
  };
}

function ApproveASubjectSuccessAction(payload) {
  return {
    type: SubjectReviewActionTypes.APPROVE_A_SUBJECT_SUCCESS,
    payload,
  };
}

/*
    Async Actions
*/

function GetAllFinishedSubjectsAction(payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(payload, headers);
      dispatch(AllFinishedSubjectsSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function RevertOrDeclineAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, body, headers);
      dispatch(RevertOrDeclineSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function ApproveASubjectAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(ApproveASubjectSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export {
  SubjectReviewActionTypes,
  AllFinishedSubjectsSuccessAction,
  RevertOrDeclineSuccessAction,
  ApproveASubjectSuccessAction,
  GetAllFinishedSubjectsAction,
  RevertOrDeclineAction,
  ApproveASubjectAction,
};
